import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from '../config/config.service';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { TimeService } from 'src/app/services/time-service/time.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})

export class CashierService {

	public customer: CustomerModel;

	constructor(
		public userSessionService: UserSessionService,
		public webservicesService: WebservicesService,
        public configService:ConfigService,
        private timeService: TimeService,
        protected platform: Platform
	){
		this.userSessionService.getCustomer().subscribe(customer => {
				this.customer = customer;
		});
	}

	getActiveTypesCategories(data?) {
		const obj: any = {
			customer_id: this.customer ? this.customer.customerId : '',
			session_token: this.userSessionService.sessionToken
		};

		if (data && data.include_types) obj.include_types = true;

		return this.webservicesService.get('cashier/get-active-payment-types-categories',	obj);
	}

	getActivePaymentTypes(data?) {
		const obj: any = {
			category: data,
			customer_id: this.customer.customerId,
			session_token: this.userSessionService.sessionToken,
            clientapp: this.configService.getClientApp()
		};
		if (data && data.include_types) obj.include_types = true;

		return this.webservicesService.get('cashier/get-active-payment-types', obj);
	}

  	callListAccounts() {
		const obj: any = {
			customer_id: this.customer.customerId,
			session_token: this.userSessionService.sessionToken,
		};
		return this.webservicesService.post('cashier/list-accounts', obj);
	}

	callVIPExternalAccounts() {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken
        }
        return this.webservicesService.post('cashier/get-global-pay-external-accounts', obj);
    }

    callAddAccount(data: any) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            payment_type_code: data.payment_type_code,
            ssn: data.ssn,
            accountType: data.accountType,
            bankName: data.bankName,
        }

        if (data.payment_type_code != null) {
            switch(data.payment_type_code)
            {
                case "MNI":
                  {
                      obj.accountNumber = data.accountNumber;
                      obj.transitNumber = data.transitNumber;
                      obj.institutionNumber = data.institutionNumber;
                      break;
                  }
                case "ACH":
                {
                    obj.routingNumber = data.routingNumber;
                    obj.accountNumber = data.accountNumber;
                    obj.transitNumber = data.transitNumber;
                    obj.institutionNumber = data.institutionNumber;
                    obj.ssn = data.ssn;
                    obj.accountType = data.accountType;
                    obj.bankName = data.bankName;
                    break;
                }
                case "FAF":
                    {
                        obj.name = data.name;
                        obj.cardNumber = data.cardNumber;
                        obj.cardExpMonth = data.cardExpMonth;
                        obj.cardExpYear = data.cardExpYear;
                        obj.ccType = data.ccType;
                        obj.address1 = data.streetGroup.street;
                        obj.address2 = data.streetGroup.street2;
                        obj.city = data.city;
                        obj.state = data.province;
                        obj.country = data.countryInfoGroup.country;
                        obj.postalCode = data.countryInfoGroup.postalCode;
                        break;
                    }
                default:
                {
                    obj.name = data.name;
                    obj.cardNumber = data.cardNumber;
                    obj.cardExpMonth = data.cardExpMonth;
                    obj.cardExpYear = data.cardExpYear;
                    obj.address1 = data.streetGroup.street;
                    obj.address2 = data.streetGroup.street2;
                    obj.city = data.city;
                    obj.state = data.province;
                    obj.country = data.countryInfoGroup.country;
                    obj.postalCode = data.countryInfoGroup.postalCode;
                }
            }
        }
        return this.webservicesService.post('cashier/add-account', obj);
    }

    public AddVipAcccount(data: any){
        let obj: Object = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            payment_type_code: "GP",
            routingNumber: data.routingNumber,
            accountNumber: data.accountNumber,
            idType: data.idType,
            idNumber: data.idNumberGroup.idNumber,
            idState: data.idState,
        };

        return this.webservicesService.post('cashier/add-account', obj);
    }

	callDeposit(data: any) {
		const obj: any = {
			customer_id: this.customer.customerId,
			session_token: this.userSessionService.sessionToken,
			amount: data.amount,
			currency_code: data.currency_code,
			payment_type_code: data.payment_type_code,
		};

		if (data.bonusCode != '' && data.bonusCode != null) {
			obj.bonusCode = data.bonusCode;
		}

		if (data.name != '' && data.name != null) {
			obj.name = data.name;
		}

		if (data.accountNumber != '' && data.accountNumber != null) {
			obj.accountNumber = data.accountNumber;
		}

		//netell
		if (data.netAccountNumber != '' && data.netAccountNumber != null) {
			obj.net_account_number = data.netAccountNumber;
		}
        
		if (data.netSecureId != '' && data.netSecureId != null) {
			obj.net_secure_id = data.netSecureId;
		}

		if (data.payment_type_code != null) {
			if ((data.payment_type_code == 'ACH' || data.payment_type_code == 'PAIBT') && data.customerAccountID) {
				//ACH (E-Check) Deposit
				obj.customerAccountID = data.customerAccountID;
			}
		}

		//GP Deposit-VIP
		if (data.key != '' && data.key != null) {
			obj.key = data.key;
		}

		if (data.routingNumber != '' && data.routingNumber != null) {
			obj.routingNumber = data.routingNumber;
		}

		return this.webservicesService.post('cashier/deposit', obj);
	}

    public callCreditCardDeposit(data: any): any{

        let obj: any = {
            customer_id: this.customer.customerId,
			session_token: this.userSessionService.sessionToken,
			amount: data.amount,
			currency_code: data.currency_code,
			payment_type_code: data.payment_type_code,
            customerAccountID: data.customerAccountID,
            cardExpMonth: data.cardExpMonth,
            cardExpYear: data.cardExpYear,
            cardCvd: data.cardCvc,
        }

        if (data.bonusCode != '' && data.bonusCode != null) {
			obj.bonusCode = data.bonusCode;
		}

        return this.webservicesService.post('cashier/deposit', obj);
    }

    public callApplepayDeposit(data: any): any{
        const obj: any = {        
            session_token: this.userSessionService.sessionToken,
            customer_id: this.customer.customerId,
            payment_type_code: data.payment_type_code,
            currency_code: data.currency_code,
            amount: data.amount,
            data: data.appleData.data,
            ephemeralPublicKey: data.appleData.header.ephemeralPublicKey,
            publicKeyHash: data.appleData.header.publicKeyHash,
            transactionId: data.appleData.header.transactionId,
            signature: data.appleData.signature,
            version: data.appleData.version
          };
        
        if (data.bonusCode != '' && data.bonusCode != null) {
            obj.bonusCode = data.bonusCode;
		}

        return this.webservicesService.post('cashier/deposit', obj);
    }

    callPayWithMyBankDeposit(data: any){
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            amount: data.amount,
            currency_code: data.currency_code,
            customerAccountID: data.customerAccountID,
            payment_type_code: "PWB"
        }

        if (data.bonusCode != "" && data.bonusCode != null) {
            obj.bonusCode = data.bonusCode;
        }

        if (data.accountNumber != "" && data.accountNumber != null) {
            obj.accountNumber = data.accountNumber;
        }

        return this.webservicesService.post('cashier/deposit', obj);
    }

	callGetTransactions(data: any) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            currency_code: data.currency_code,
            pageno: data.pageno,
            date_from: data.date_from,
            date_to: data.date_to
        }

        return this.webservicesService.post('cashier/get-transaction-history', obj);
    }

	sendTransactionsEmail(data: any) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            currency_code: data.currency_code,
            date_from: data.date_from,
            date_to: data.date_to
        }

        return this.webservicesService.post('cashier/send-transaction-history', obj);
    }


    /*
     *  GET /cashier/download-win-loss-balance-summary
    */
    downloadAggregateWinLossBalance(data: any) {
        let url = '';
        let webservice_endpoint: string = this.configService.getConfig()['RESOURCE_WEBSERVICE_ENDPOINT'];
        let webservice_final_endpoint: string;
        if (!webservice_endpoint.endsWith("/")) {
            webservice_final_endpoint = webservice_endpoint + '/';
        } else {
            webservice_final_endpoint = webservice_endpoint;
        }
        let params = new URLSearchParams();
        params.set('customer_id', (this.customer.customerId).toString());
        params.set('session_token', this.userSessionService.sessionToken);
        params.set('date_from', data.date_from);
        params.set('date_to', data.date_to);
        url = `${webservice_final_endpoint}cashier/download-win-loss-balance-summary?` + params.toString();
        return url;
    }

    /*
     *  GET /cashier/download-daily-win-loss-balance
    */
    downloadGetDailyWinLossBalance(data: any) {
        let url = '';
        let webservice_endpoint = this.configService.getConfig()['RESOURCE_WEBSERVICE_ENDPOINT'];
        let webservice_final_endpoint: string;
        if (!webservice_endpoint.endsWith("/")) {
            webservice_final_endpoint = webservice_endpoint + '/';
        } else {
            webservice_final_endpoint = webservice_endpoint;
        }
        let params = new URLSearchParams();
        params.set('customer_id', (this.customer.customerId).toString());
        params.set('session_token', this.userSessionService.sessionToken);
        params.set('date_from', data.date_from);
        params.set('date_to', data.date_to);   
        url = `${webservice_final_endpoint}cashier/download-daily-win-loss-balance?` + params.toString();
        return url;
    }
	 /*
     *  GET /cashier/get-daily-win-loss-balance
    */
	 callGetDailyWinLossBalance(data: any) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            pageno: data.pageno,
            date_from: data.date_from,
            date_to: data.date_to
        }
        return this.webservicesService.get('cashier/get-daily-win-loss-balance', obj);
    }

    /*
     *  GET /cashier/get-win-loss-balance-summary
    */
    callGetAggregateWinLossBalance(data: any) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            pageno: data.pageno,
            date_from: data.date_from,
            date_to: data.date_to
        }
        return this.webservicesService.get('cashier/get-win-loss-balance-summary', obj);
    }

    setupPayWithMyBank(): void {
        const payWithMyBankUrl = ( this.platform.is( 'capacitor') || this.platform.is('cordova') ? 
            this.configService.getConfig().FEATURE_PWMB_MOBILE_SCRIPT_URL : this.configService.getConfig().FEATURE_PWMB_WEB_SCRIPT_URL);

        if (payWithMyBankUrl && payWithMyBankUrl !== "") {
            const script = document.createElement('script');
            script.innerHTML = `(function(a,b,c,d){
                a='${payWithMyBankUrl}';
                b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
                a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
                })();`;
    
            document.head.appendChild(script);
        }
    }
 
    getPwbEncryptedSsn() {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken
        }
        return this.webservicesService.get('cashier/pwb-get-encrypted-ssn', obj);
    }

    getPwbRequestSignature(query) {
        let obj: any = {
            customer_id: this.customer.customerId,
            query: query,
            session_token: this.userSessionService.sessionToken
        }

        return this.webservicesService.get('cashier/pwb-get-request-signature', obj);
    }

    callRemoveAccount(customerAccountID: string) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            customerAccountID: customerAccountID
        }

        return this.webservicesService.post('cashier/remove-account', obj);
    }

    getPaynearmeUrl(bonusCode, bonus_type = "CASINO", theme = "kindred") {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken
        }
        if (bonusCode != "" && bonusCode != null) {
            obj.bonusCode = bonusCode;
        }
        obj.bonus_type = bonus_type;
        obj.theme = theme;
        return this.webservicesService.get('cashier/get-paynearme-url', obj);
    }

    getAuthToken(amount, depositType, transactionId) {
        let obj: any = {
            customerId: this.customer.customerId,
            clientapp: this.configService.getClientApp()
        }
        //should be removed
        if(depositType == "etransfer") {
            obj.email = this.customer.email;
            obj.name = this.customer.firstName + " " + this.customer.lastName;

            obj.type = 'ETI';
        }

        //this is for combined payment
        if(depositType == "CPI") {
            obj.email = this.customer.email;
            obj.name = this.customer.firstName + " " + this.customer.lastName;
            obj.transactionId = transactionId;
            obj.site = "https://www.mohegansuncasino.com/";
            obj.type = 'CPI';
        }


        obj.amount = amount;

        return this.webservicesService.post('external/interac-token-authentication', obj);
    }

    public getExternalNeosurf(data: any){
        const obj: any = {
            amount: data.amount,
            currency: data.currencyCode,
            customer_id: this.customer.customerId,
            merchantTransactionId: data.merchantTransactionId,
            skindId: null
        }

        return this.webservicesService.get('external/neosurf-post', obj);
    }

    public callPayNearMeV2(data: any) {
        const obj: any = {
            amount: data.amount,
            currency_code: data.currency_code,
            payment_type_code: data.payment_type_code,
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken
        }

        if (data.bonusCode != "" && data.bonusCode != null) {
            obj.bonusCode = data.bonusCode;
        }

        return this.webservicesService.post('cashier/deposit', obj);
    }

    public callPayNearMeV2Cash(data: any) {
        const obj: any = {
            currency_code: data?.currency_code,
            payment_type_code: 'CASH', //
            customer_id: this.customer?.customerId, //
            session_token: this.userSessionService.sessionToken,
            bonus_code: data?.bonusCode
        }

        return this.webservicesService.get('cashier/get-paynearme-token', obj);
    }

    callGetMigrationTransactions(data: any) {let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.sessionToken,
        currency_code: data.currency_code,
        pageno: data.pageno,
        date_from: data.date_from,
        date_to: data.date_to
    }

    return this.webservicesService.get('migration/get-transaction-history-resorts', obj);     }
    

    /*
     *  GET / migration/get-win-loss-balance-summary
    */
    callGetMigrationDailyWinLossBalance(data: any) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.sessionToken,
            pageno: data.pageno,
            date_from: data.date_from,
            date_to: data.date_to
        }
        return this.webservicesService.get('migration/get-win-loss-balance-summary', obj);
      }

      


}
